import { action, computed, makeObservable, observable, reaction } from 'mobx';
import { LayersNodeModel, ComparisonNodeBaseModel } from '..';
import { ContractComparisonPanel } from '../../types';
import ComparisonInputGroupModel from './ComparisonInputGroupModel';

export default class LayersComparisonNodeModel extends ComparisonNodeBaseModel {
    groups: ComparisonInputGroupModel[] = [];

    constructor(
        nodeId: string,
        nodeName: string,
        readonly layerId: string,
        predefinedPanels?: ContractComparisonPanel[],
        readonly newNode?: LayersNodeModel,
        readonly previousNode?: LayersNodeModel
    ) {
        super(nodeId, nodeName, predefinedPanels);

        makeObservable(this, {
            groups: observable.ref,
            initializeGroups: action,
            inputIds: computed,
            newLayer: computed,
            previousLayer: computed
        });

        this.initializeGroups();

        this.reactions.push(
            reaction(
                () => this.inputIds,
                () => this.initializeGroups()
            )
        );
    }

    dispose() {
        super.dispose();
        this.groups.forEach(group => group.dispose());
    }

    initializeGroups() {
        this.groups.forEach(group => group.dispose());
        this.groups = this.panels.map(
            panel =>
                new ComparisonInputGroupModel(
                    panel.id,
                    panel.inputIds,
                    inputId => this.newLayer?.getInputById(inputId),
                    inputId => this.previousLayer?.getInputById(inputId)
                )
        );
    }

    get newLayer() {
        return this.newNode?.layers.find(layer => layer.id === this.layerId);
    }

    get previousLayer() {
        return this.previousNode?.layers.find(layer => layer.id === this.layerId);
    }

    get inputIds() {
        return this.getInputIds(
            this.newLayer?.inputs.map(input => input.id),
            this.previousLayer?.inputs.map(input => input.id)
        );
    }
}
